import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./auth.scss";
import LoginForm from "./forms/LoginForm";
import { BadgeCheck, Headphones, Smartphone } from "lucide-react";
import AuthRecommendedDeal from "./AuthRecommendedDeal";


const Login = () => {
  const navigate = useNavigate();

  return (
    <section className="auth-section auth-section--login">
      <div className="left">
        <div className="auth-hero-panel">
          <Link to="/" className="auth-brand">
            <img src="/images/Android.png" alt="Teleport Now Logo" />
            <span>Teleport Now</span>
          </Link>

          <div className="auth-hero-copy">
            <p className="auth-eyebrow">Welcome back</p>
            <h1>Pick up your trip planning right where you left off.</h1>
            <p>
              Sign in to manage eSIMs, travel deals, bookings, rewards, and support
              from one simple travel account.
            </p>
          </div>

          <div className="auth-benefit-grid">
            <div>
              <Smartphone size={20} />
              <span>Instant eSIM access</span>
            </div>
            <div>
              <BadgeCheck size={20} />
              <span>App-only deals</span>
            </div>
            <div>
              <Headphones size={20} />
              <span>Travel support</span>
            </div>
          </div>

          <AuthRecommendedDeal />
        </div>
      </div>

      <div className="right">
        <LoginForm onLoginSuccess={() => navigate("/")} />
      </div>
    </section>
  );
};

export default Login;
